import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  padding: ${size[24]};
  display: flex;
  color: ${theme.palette.text.title};
`

export const content = css`
  width: 100%;
  max-width: ${width.container.compact};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${size[24]};

  ${breakpoint.up('smMd')} {
    margin: 0 auto;
    max-width: ${width.container.wider};
    gap: ${size[48]};
  }
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  max-width: ${width.modal.compact};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const brands = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${size[32]};
  justify-items: center;

  & > * {
    max-width: 112px;
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    display: flex;
    flex-wrap: wrap;
    gap: ${size[32]};
    justify-content: center;
    align-items: center;

    & > * {
      flex: 0 1 112px;
      margin: ${size[8]};
    }
  }
`
